/// <summary>
/// Represents the status of an FMCSA API operation result.
/// </summary>
export enum ApiResultStatus {
    /// <summary>
    /// The operation completed successfully.
    /// </summary>
    success,

    /// <summary>
    /// The operation failed.
    /// </summary>
    failed,

    /// <summary>
    /// The operation was skipped due to being disabled in the configuration
    /// </summary>
    disabled
}